import { useCallback } from 'react';
import { useGetAuthTokensLazyQuery } from '@frameio/graphql-client/graphql/features/integrations';
import { auth } from '@frameio/utils/auth';

export const useStoreAccessTokensToCookies = () => {
  const [getAuthTokens] = useGetAuthTokensLazyQuery({
    context: {
      resolveWithUXP: true,
    },
  });
  const storeAccessTokensToCookies = useCallback(async () => {
    const authTokens = await getAuthTokens();
    if (authTokens?.data?.getAuthTokens?.accessToken) {
      auth.setTokens({
        access: authTokens?.data?.getAuthTokens?.accessToken ?? undefined,
      });
    }
  }, [getAuthTokens]);

  return storeAccessTokensToCookies;
};
